export const equals = (thisObject, other) => {
  if (thisObject === undefined && other == undefined) {
    return true;
  } else if (thisObject === undefined && other !== undefined) {
    return false;
  } else if (thisObject !== undefined && other === undefined) {
    return false;
  } else {
    for (const p in thisObject) {
      if (typeof (thisObject[p]) !== typeof (other[p])) {
        return false;
      }
      if ((thisObject[p] === null) !== (other[p] === null)) {
        return false;
      }
      switch (typeof (thisObject[p])) {
        case 'undefined':
          if (typeof (other[p]) != 'undefined') {
            return false;
          }
          break;
        case 'object':
          if (thisObject[p] !== null && other[p] !== null && (thisObject[p].constructor.toString() !== other[p].constructor.toString() || !equals(thisObject[p], other[p]))) {
            return false;
          }
          break;
        case 'function':
          if (p != 'equals' && thisObject[p].toString() != other[p].toString()) {
            return false;
          }
          break;
        default:
          if (thisObject[p] !== other[p]) {
            return false;
          }
      }
    }
    return true;
  }};
